import styled from '@emotion/styled'

export const TopLine = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 21px;
  align-self: stretch;
`
